export type HistoryDayGroup<T> = {
  key: string;
  label: string;
  items: T[];
};

const dayInMs = 24 * 60 * 60 * 1000;

const startOfDay = (date: Date): Date => {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
};

const dayLabel = (date: Date): string => {
  const today = startOfDay(new Date());
  const day = startOfDay(date);
  const diffDays = Math.round((today.getTime() - day.getTime()) / dayInMs);

  if (diffDays <= 0) return "Dzisiaj";
  if (diffDays === 1) return "Wczoraj";

  return day.toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" });
};

export const groupHistoryByDay = <T extends { viewedAt: Date }>(items: T[]): HistoryDayGroup<T>[] => {
  const groups: HistoryDayGroup<T>[] = [];
  const byKey = new Map<string, HistoryDayGroup<T>>();

  for (const item of items) {
    const key = startOfDay(item.viewedAt).toISOString();
    const existing = byKey.get(key);

    if (existing) {
      existing.items.push(item);
      continue;
    }

    const group: HistoryDayGroup<T> = { key, label: dayLabel(item.viewedAt), items: [item] };
    byKey.set(key, group);
    groups.push(group);
  }

  return groups;
};
